
import React, { Component } from 'react';

import Game from './game/Game';

import SideBar from './sidebar/SideBar';

import BonusGame from './game/BonusGame';

import InstructionsOverlay from './instructions/InstructionsOverlay';

import BonusInstructionsOverlay from './instructions/BonusInstructionsOverlay';

import ResultsOverlay from './results/ResultsOverlay';

import FinalResultsOverlay from './results/FinalResultsOverlay';

import BonusResultsOverlay from './results/BonusResultsOverlay';
import BeforeResultsOverlay from './results/BeforeResultsOverlay';

import RewardAdContainer from '../ads/RewardAdContainer';

import './../../../scss/App.scss';
import { AD_MORE_TIME_CLICKED, AD_REPLAY_CLICKED, AD_FINAL_RESULTS } from '../../utils/constants';
import { trackingWrapper } from '../../utils/analytics';


class GamePage extends Component {

	constructor(props){
		super(props);

		this.totalRoundDurationInSeconds = window.config.roundTimer;
		this.totalBonusRoundDurationInSeconds = window.config.bonusRoundTimer;
		this.totalRounds = window.config.rounds.length;
		this.roundsData = [...window.config.rounds];

		this.timer = null;

		this.showAdAfterThisManyGames = window.config.videoAd.showAdAfterThisManyGames;

		this.state = {
			showInstructions : true,
			showBonusInstructions : false,
			hasReachedBonusRound : false,
			questionSet : null,
			totalAnswers : null,
			totalAnsweredCorrect : 0,
			currentRound : 0,
			showBeforeResults : false,
			showRoundResults : false,
			showFinalResults : false,
			showBonusResults : false,
			uniqueID : 0,
			bonusQuestionSets : [],
			timerMsg : "00:00",
			timerRemaining : this.totalRoundDurationInSeconds,
			showAnswers : false,
			roundPoints : 0,
			totalPoints : 0,
			roundIsStarted : false,
			blurGame : true,
			showVideoAd : false,
			videoAdId : 0,
			videoAdCallback : null,
			gamePlays : 1,
			showNeedMoreTimeBtn : false,
			needMoreTimeBtnHasWatchedThisRound : false,
			replayCount : 0
		}

		this.handleCorrectAnswer = this.handleCorrectAnswer.bind(this);
		this.handleNextRound = this.handleNextRound.bind(this);
		this.handlePlayAgainBtn = this.handlePlayAgainBtn.bind(this);
		this.handleLoginBtn = this.handleLoginBtn.bind(this);
		this.handleLeaderboardBtn = this.handleLeaderboardBtn.bind(this);
		this.handleVideoOverlayClose = this.handleVideoOverlayClose.bind(this);
		this.handleVideoAdCloseFromGamePlays = this.handleVideoAdCloseFromGamePlays.bind(this);
		this.handleAnswerRevealComplete = this.handleAnswerRevealComplete.bind(this);
		this.handleNeedMoreTimeBtnClick = this.handleNeedMoreTimeBtnClick.bind(this);
		this.handleVideoAdCloseFromNeedMoreTime = this.handleVideoAdCloseFromNeedMoreTime.bind(this);
		this.handleFinalResultVideoAdClose = this.handleVideoAdCloseFinalResult.bind(this);
		this.handleBeforeResults = this.handleBeforeResultsClick.bind(this);
		this.handleGiveUp = this.handleGiveUp.bind(this);

		this.gameTimerTick = this.gameTimerTick.bind(this);
		this.initRound = this.initRound.bind(this);
		this.initBonusRound = this.initBonusRound.bind(this);
	}

	componentDidMount(){
		window.TweenMax.to(this.refs.wipe, .5, {"height": "0%"});
	}

	initRound(){
		//console.log("----------- GamePage :: initRound");
		window.sounds.startButtonClick.play();

		this.setState({
			currentRound : this.state.currentRound + 1,
			showInstructions : false,
			showRoundResults : false,
			timerMsg : this.formatTimeFromSeconds(this.totalRoundDurationInSeconds),
			timerRemaining : this.totalRoundDurationInSeconds,
			roundPoints : 0,
			roundIsStarted : true,
			needMoreTimeBtnHasWatchedThisRound : false,
			showNeedMoreTimeBtn : false
		});

		const _this = this;

		setTimeout(function(){
			_this.initRandomQuestion();
			_this.startGameTimer();

			_this.setState({
				blurGame : false
			});
		},10);

		//tracking
		trackingWrapper('event', 'ASgame-round-' + (this.state.currentRound + 1) + '-start', {'event_category':'america-says-game'});

		if (this.state.currentRound === 0) {
			trackingWrapper('event', 'ASgame-total-plays', {'event_category':'america-says-game'});
		}
		
	}

	initBonusRound(){
		//console.log("============ GamePage :: initBonusRound");
		window.sounds.startButtonClick.play();

		this.setState({
			currentRound : this.state.currentRound + 1,
			showBonusInstructions : false,
			timerMsg : this.formatTimeFromSeconds(this.totalBonusRoundDurationInSeconds),
			timerRemaining : this.totalBonusRoundDurationInSeconds,
			roundIsStarted : true,
			roundPoints : 0,
			needMoreTimeBtnHasWatchedThisRound : false,
			showNeedMoreTimeBtn : false
		});

		const _this = this;

		setTimeout(function(){
			_this.initBonusQuestions();
			_this.startGameTimer();

			_this.setState({
				blurGame : false
			});
		},10);

		//tracking
		trackingWrapper('event', 'ASgame-bonus-round-start', {'event_category':'america-says-game'});
	}

	initBonusQuestions(){

		var bonusQuestions = [];
		var totalSets = window.config.bonusRound.sets.length;
		var count = 0;

		//console.log("GamePage :: initBonusQuestions - totalSets", totalSets);

		// loop thru pool to find x sets of bonus questions, if not enough, reset the pool with full list
		while(bonusQuestions.length < totalSets){
			const set = window.config.bonusRound.sets[count].answers;
			var bonusQuestionsPool = window.bonusQuestionsPool[set];

			//console.log("============ GamePage :: initBonusQuestions - set: ", set);
			//console.log("GamePage :: initBonusQuestions - bonusQuestionsPool: ", bonusQuestionsPool);

			// get random question
			let bonusQuestionSet = bonusQuestionsPool[Math.floor(Math.random() * bonusQuestionsPool.length)];

			// add random question to the set array
			bonusQuestions.push(bonusQuestionSet);

			// update pool by removing the randomly chosen one
			const newQuestions = [...bonusQuestionsPool.filter(x => x !== bonusQuestionSet)];

			// if pool is empty, reset the pool with full list
			if(newQuestions.length === 0){
				window.bonusQuestionsPool[set] = [...window.bonusQuestions[set]];

				// if list is more than 1, remove the selected so it doesn't get chosen back to back
				if(window.bonusQuestions[set].length > 1){
					window.bonusQuestionsPool[set] = [...window.bonusQuestionsPool[set].filter(x => x !== bonusQuestionSet)];
				} 
			}
			else {
				bonusQuestionsPool = [...newQuestions];
			}

			count++;
		}

		//console.log("GamePage :: initBonusQuestions - bonusQuestions = ", bonusQuestions);

		this.setState({
			bonusQuestionSets : bonusQuestions,
			uniqueID : this.state.uniqueID + 1
		});
	}

	initRandomQuestion(){
		//console.log("-----------------------------------------------");
		//console.log("GamePage :: initRandomQuestion - round: ", this.state.currentRound);

		const difficulty = window.config.rounds[(this.state.currentRound - 1)].difficulty;
		var questionsPool = window.questionsPool[difficulty];

		//console.log("GamePage :: initRandomQuestion - difficulty: ", difficulty);
		//console.log("GamePage :: initRandomQuestion - start questionsPool ######: ", questionsPool);

		
		// get random question
		let questionSet = questionsPool[Math.floor(Math.random() * questionsPool.length)];

		//console.log("GamePage :: initRandomQuestion - questionSet chosen: ", questionSet);

		// remove chosen question from pool
		const newQuestionsPool = [...questionsPool.filter(x => x !== questionSet)];

		//console.log("GamePage :: initRandomQuestion - new pool: ", newQuestionsPool);



		// if pool is empty, reset the pool with full list
		if(newQuestionsPool.length === 0){
			window.questionsPool[difficulty] = [...window.questions[difficulty]];

			// if list is more than 1, remove the selected so it doesn't get chosen back to back
			if(window.questions[difficulty].length > 1){
				window.questionsPool[difficulty] = [...window.questionsPool[difficulty].filter(x => x !== questionSet)];
			}
		}
		else {
			window.questionsPool[difficulty] = [...newQuestionsPool];
		}

		//
		/*
		console.log("=======================");
		console.log("GamePage :: initRandomQuestion - parsed data : ", (this.parseAnswersOrder(questionSet)));
		console.log("----------");
		console.log("GamePage :: initRandomQuestion - double check - window.questionsPool[easy]: ", window.questionsPool["easy"]);
		*/

		this.setState({
			questionSet : this.parseAnswersOrder(questionSet),
			totalAnswers : questionSet.answers.length,
			totalAnsweredCorrect : 0,
			uniqueID : this.state.uniqueID + 1
		});
	}

	parseAnswersOrder(questionSet){
		//console.log("GamePage :: parseAnswersOrder - questionSet : ", questionSet);

		var newQuestionSet = {...questionSet};

		const answers = newQuestionSet.answers;

		var newAnswersOrder = [];
		newAnswersOrder[0] = "" + answers[0];
		newAnswersOrder[1] = "" + answers[1];
		newAnswersOrder[2] = "" + answers[4];
		newAnswersOrder[3] = "" + answers[2];
		newAnswersOrder[4] = "" + answers[5];
		newAnswersOrder[5] = "" + answers[3];
		newAnswersOrder[6] = "" + answers[6];

		newQuestionSet.answers = [...newAnswersOrder];

		return {...newQuestionSet};
	}

	startGameTimer(){
		this.timer = setInterval(this.gameTimerTick, 1000);

		// stop all bg music
		window.sounds.introBg.stop();
		window.sounds.roundBg.stop();
		window.sounds.bonusBg.stop();
		window.sounds.gameOverBg.stop();

		// if bonus round
		if(this.state.currentRound > this.totalRounds){
			window.sounds.bonusBg.play();
			window.sounds.bonusBg.volume(1);
		}
		// else if regular rounds
		else{
			window.sounds.roundBg.play();
			window.sounds.roundBg.volume(1);
		}
	}

	stopGameTimer(){
		console.log("GamePage :: stopGameTimer");
		clearInterval(this.timer);

		// if stopped timer due to need more time button
		if(this.state.videoAdCallback !== this.handleVideoAdCloseFromNeedMoreTime){
			window.sounds.bonusBg.volume(0);
			window.sounds.roundBg.volume(0);
		}
		// if bonus round
		else if(this.state.currentRound > this.totalRounds){
			window.sounds.bonusBg.volume(.2);
		}
		// else if regular rounds
		else{
			window.sounds.roundBg.volume(.2);
		}
	}

	gameTimerTick(){
		const newTime = this.state.timerRemaining - 1;

		if(newTime < 1){
			// handle out of time
			this.stopGameTimer();

			this.handleOutOfTime();
		}
		else{
			// update timer
			this.setState({
				timerRemaining : newTime,
				timerMsg : this.formatTimeFromSeconds(newTime)
			});

			// play sound if less than 5 seconds left
			if(newTime <= 5){
				window.sounds.timerRunningOut.play();
			}
		}

		// show need more time button
		if(newTime < window.config.needMoreTimeBtn.showAtRemainingSecs && this.state.needMoreTimeBtnHasWatchedThisRound === false){
			console.log("GamePage :: gameTimerTick - show more time button to true");
			this.setState({
				showNeedMoreTimeBtn : true
			});
		}
	}

	formatTimeFromSeconds(seconds){
		const minutesRemaining = Math.floor(seconds / 60);
		const secondsRemaining = seconds % 60;

		return "" + this.formatTimerDigits(minutesRemaining) + ":" + this.formatTimerDigits(secondsRemaining);
	}

	formatTimerDigits(num){
		if(String(num).length === 1){
			return "0" + num;
		}

		return num;
	}

	handleCorrectAnswer(){
		console.log("GamePage :: handleCorrectAnswer");

		// points to give
		var pointsRewarded = window.config.rounds[this.state.currentRound - 1].correctAnswerPointsAwarded;

		const totalAnsweredCorrect = this.state.totalAnsweredCorrect + 1;

		this.setState({
			totalAnsweredCorrect : totalAnsweredCorrect,
			roundPoints : this.state.roundPoints + pointsRewarded,
			totalPoints : this.state.totalPoints + pointsRewarded
		});

		// if all answers completed
		if(totalAnsweredCorrect === this.state.totalAnswers){
			console.log("GamePage :: handleCorrectAnswer --- last question correct - handle end of round");

			// tracking
			// trackingWrapper('event', 'game-round-[#]-duration', {'event_label':this.state.timerRemaining,'event_category':'america-says-game'});

			//

			const _this = this;

			// need to stop round ahead of next step so "reveal" button can dissappear first
			_this.setState({
				roundIsStarted : false
			});


			// add bonus points for all completed
			const bonusPointsRewarded = window.config.rounds[this.state.currentRound - 1].allCorrectBonusPointsAwarded;

			this.stopGameTimer();

			setTimeout(function(){
				// if not final round
				if(_this.state.currentRound < _this.totalRounds){
					_this.setState({
						showRoundResults : true,
						roundPoints : _this.state.roundPoints + bonusPointsRewarded,
						totalPoints : _this.state.totalPoints + bonusPointsRewarded,
						blurGame : true
					});
				}
				// if final round and will go to bonus round
				else if( (_this.state.totalPoints + pointsRewarded) >= window.config.bonusRound.bonusRoundPointsThreshold ){
					_this.setState({
						showFinalResults : true,
						roundPoints : _this.state.roundPoints + bonusPointsRewarded,
						totalPoints : _this.state.totalPoints + bonusPointsRewarded,
						blurGame : true
					});
				}
				// else show replay screen
				else {
					_this.setState({
						roundPoints : _this.state.roundPoints + bonusPointsRewarded,
						totalPoints : _this.state.totalPoints + bonusPointsRewarded,
						blurGame : true
					});
					_this.showBeforeResultScreen(_this);
				}
			}, 2000);
		}
	}

	handleOutOfTime(){
		//alert("You ran out of time! Here are the answers...");

		// tracking
		// trackingWrapper('event', 'game-round-[#]-timeout', {'event_label':this.totalRoundDurationInSeconds,'event_category':'america-says-game'});

		//

		window.sounds.buzzer.play("buzzer");

		const _this = this;

		_this.setState({
			roundIsStarted : false,
			timerMsg : "00:00"
		});

		setTimeout(function(){
			// show answers
			_this.setState({
				showAnswers : true
			});
		}, 2000);
	}

	handleAnswerRevealComplete(){
		console.log("GamePage :: handleAnswerRevealComplete");

		const _this = this;

		
		// if not last round
		if(_this.state.currentRound < _this.totalRounds){
			setTimeout(function(){
				_this.setState({
					showRoundResults : true,
					showAnswers : false,
					blurGame : true
				});
			}, 3000);
		}
		// if last round
		else if(_this.state.currentRound === _this.totalRounds){
			setTimeout(function(){	
				// if quality for bonus round
				if(_this.state.totalPoints >= window.config.bonusRound.bonusRoundPointsThreshold){
					_this.setState({
						showFinalResults : true,
						showAnswers : false,
						blurGame : true
					});
				}
				// else show game over screen
				else{
					_this.setState({
						showAnswers : false,
						blurGame : true
					});
					_this.showBeforeResultScreen(_this);
				}
			}, 3000);
		}
		// if bonus round
		else {
			setTimeout(function(){
				_this.setState({
					showAnswers : false,
					blurGame : true
				});
				_this.showBeforeResultScreen(_this);
			}, 3000);
		}
	}

	handleNextRound(){
		console.log("GamePage :: handleNextRound - currentRound ", this.state.currentRound);

		// if not last round
		if(this.state.currentRound < this.totalRounds){
			console.log("GamePage :: ------- handleNextRound - not last round");

			this.initRound();
			/*
			this.setState({
				currentRound : this.state.currentRound + 1,
				showRoundResults : false,
				timerMsg : this.formatTimeFromSeconds(this.totalRoundDurationInSeconds),
				timerRemaining : this.totalRoundDurationInSeconds,
				roundPoints : 0,
				roundIsStarted : true
			});

			const _this = this;

			setTimeout(function(){
				_this.initRandomQuestion();
				_this.startGameTimer();

				_this.setState({
					blurGame : false
				});
			},10);

			window.sounds.startButtonClick.play();
			*/
		}
		// if last round
		else if(this.state.currentRound >= this.totalRounds){
			console.log("GamePage :: ++++++++++ handleNextRound - last round");

			// if quality for bonus round
			if(this.state.totalPoints >= window.config.bonusRound.bonusRoundPointsThreshold){
				console.log("GamePage :: ++++++++++ handleNextRound - made to bonus");

				this.setState({
					currentRound : this.state.currentRound + 1,
					showFinalResults : false,
					showBonusInstructions : true,
					hasReachedBonusRound : true,
					roundPoints : 0
				});

				/*
				const _this = this;

				setTimeout(function(){
					_this.initBonusRound();
				},10);
				*/
				//window.sounds.startButtonClick.play();
				//this.initBonusRound();
			}
			else{
				console.log("GamePage :: !!!!!!!!!! handleNextRound - failed to bonus");
				this.setState({
					showFinalResults : false,
					showBonusInstructions : false,
					roundPoints : 0
				});
				this.showBeforeResultScreen();
			}
		}
	}

	handleBonusCompleted(){
		console.log("GamePage :: handleBonusCompleted");

		this.stopGameTimer();
		
		// award bonus round points
		const _this = this;

		_this.setState({
			totalPoints : _this.state.totalPoints + window.config.bonusRound.bonusPointsAwarded,
			roundIsStarted : false
		});

		setTimeout(function(){
			_this.setState({
				blurGame : true
			});
			_this.showBeforeResultScreen(_this);
		}, 2000);
	}

	handlePlayAgainBtn(){
		//console.log("GamePage :: handlePlayAgainBtn");

		// tracking 
		trackingWrapper('event', 'ASgame-game-replay', {'event_category':'america-says-game'});
		trackingWrapper('event', 'ASgame-game-replay-' + (this.state.replayCount + 1), {'event_category':'america-says-game'});

		//

		window.sounds.buttonClick.play();

		//

		// if reached game played threshold, show video ad
		if(this.state.gamePlays >= this.showAdAfterThisManyGames){
			this.setState({
				showVideoAd : AD_REPLAY_CLICKED,
				showInstructions : false,
				showBonusInstructions : false,
				showRoundResults : false,
				showFinalResults : false,
				showBonusResults : false,
				currentRound : 0,
				timerRemaining : this.totalRoundDurationInSeconds,
				roundPoints : 0,
				totalPoints :0,
				gamePlays : 1,
				videoAdCallback : this.handleVideoAdCloseFromGamePlays,
				hasReachedBonusRound : false,
				replayCount : this.state.replayCount + 1,
			});
		}
		else{
			this.setState({
				showVideoAd : false,
				videoAdId: 0,
				showInstructions : true,
				showBonusInstructions : false,
				showRoundResults : false,
				showFinalResults : false,
				showBonusResults : false,
				currentRound : 0,
				timerRemaining : this.totalRoundDurationInSeconds,
				roundPoints : 0,
				totalPoints :0,
				gamePlays : (this.state.gamePlays + 1),
				hasReachedBonusRound : false,
				replayCount : this.state.replayCount + 1,
			});
		}
	}

	handleLoginBtn(){
		console.log("GamePage :: handleLoginBtn");

		window.sounds.buttonClick.play();
	}

	handleLeaderboardBtn(){
		//console.log("GamePage :: handleLeaderboardBtn");
		window.sounds.buttonClick.play();

		if (window.config && window.config.buttons && window.config.buttons.leaderboard && window.config.buttons.leaderboard.redirect) {

			//tracking
			if (window.config.buttons.leaderboard.externalTracking) {
				trackingWrapper('event', 'ASGame-external-link', {'event_label':window.config.buttons.leaderboard.externalTracking,'event_category':'america-says-game'});
			}
			
			window.open(window.config.buttons.leaderboard.redirect, '_blank');
		} else {
			this.props.showPage("landing");
		}
	}

	handleGiveUp(){
		this.stopGameTimer();

		// show answers
		this.setState({
			showAnswers : true,
			roundIsStarted : false
		});
	}

	handleVideoOverlayClose(rewardComplete=true){
		console.log('handleVideoOverlayClose');
		this.state.videoAdCallback(rewardComplete);
	}

	handleVideoAdCloseFromGamePlays(){
		this.setState({
			showVideoAd : false,
			videoAdId : 0,
			showInstructions : true,
			videoAdCallback : null
		});
	}

	handleVideoAdCloseFromNeedMoreTime(rewardComplete=true){
		this.setState({
			showVideoAd : false,
			videoAdId : 0,
			videoAdCallback : null,
			needMoreTimeBtnHasWatchedThisRound : true,
			showNeedMoreTimeBtn : false
		});

		if (rewardComplete) {
			this.setState({
				timerRemaining : this.state.timerRemaining + window.config.needMoreTimeBtn.timeAwarded,
				timerMsg : this.formatTimeFromSeconds(this.state.timerRemaining + window.config.needMoreTimeBtn.timeAwarded),
			});
		}
		
		const _this = this;
		
		setTimeout(function(){
			_this.startGameTimer();
		}, 10);
	}

	handleNeedMoreTimeBtnClick(){
		this.setState({
			showVideoAd : AD_MORE_TIME_CLICKED,
			videoAdCallback : this.handleVideoAdCloseFromNeedMoreTime,
		});

		const _this = this;

		setTimeout(function(){
			_this.stopGameTimer();
		}, 10);
	}

	handleVideoAdCloseFinalResult() {
		console.log('handleVideoAdCloseFinalResult');
		this.setState({
			showVideoAd : false,
			videoAdId: 0,
			videoAdCallback: null,
			showBonusResults: true
		});
	}

	handleBeforeResultsClick() {

		window.sounds.gameOverBg.stop();
		
		this.showFinalResultVideoAd();
	}

	showFinalResultVideoAd(self) {
		const _this = self || this;
		const videoId = window.config.videoAd.resultVideo || 0;

		_this.setState({
			showVideoAd : AD_FINAL_RESULTS,
			videoAdId : videoId,
			videoAdCallback: _this.handleFinalResultVideoAdClose,
			showBonusResults: false,
			showBeforeResults: false,
		});
	}

	showBeforeResultScreen(self) {
		const _this = self || this;

		_this.setState({
			showBeforeResults: true
		});
	}

	renderInstructionsOverlay(){
		if(this.state.showInstructions){
			return (
				<InstructionsOverlay initRound={this.initRound} timer={this.totalRoundDurationInSeconds} />
			);
		}
		else if(this.state.showBonusInstructions){
			return (
				<BonusInstructionsOverlay initBonusRound={this.initBonusRound} timer={this.totalBonusRoundDurationInSeconds} />
			);
		}
	}

	renderResultsOverlay(){
		

		if(this.state.showRoundResults){
			
			const bonusRoundThreshold = window.config.bonusRound.bonusRoundPointsThreshold;
			const missingPoints = bonusRoundThreshold - this.state.totalPoints;
			
			var renderThresholdMsg = "";

			if(this.state.totalPoints < bonusRoundThreshold){
				renderThresholdMsg = <div className="thresholdMsg">(You need another {missingPoints}pts to qualify for The Bonus Round!)</div>
			}

			return(
				<ResultsOverlay round={this.state.currentRound} roundPoints={this.state.roundPoints} totalPoints={this.state.totalPoints} handleNextRound={this.handleNextRound} renderThresholdMsg={renderThresholdMsg} /> 
			);
		}
		else if(this.state.showBeforeResults) {
			return(
				<BeforeResultsOverlay handleNextRound={this.handleBeforeResults} />
			);
		}
		else if(this.state.showFinalResults){

			return(
				<FinalResultsOverlay round={this.state.currentRound} roundPoints={this.state.roundPoints} totalPoints={this.state.totalPoints} handleNextRound={this.handleNextRound} />
			);
		}
		else if(this.state.showBonusResults){

			return(
				<BonusResultsOverlay store={this.props.store} totalPoints={this.state.totalPoints} handlePlayAgainBtn={this.handlePlayAgainBtn} handleLoginBtn={this.handleLoginBtn} handleLeaderboardBtn={this.handleLeaderboardBtn} hasReachedBonusRound={this.state.hasReachedBonusRound} />
			);
		}
	}

	renderGame(){
		if(this.state.currentRound > this.totalRounds){
			return(
				<BonusGame 
					bonusQuestionSets={this.state.bonusQuestionSets} 
					handleBonusCompleted={() => this.handleBonusCompleted()} 
					key={this.state.uniqueID} 
					showAnswers={this.state.showAnswers} 
					handleAnswerRevealComplete={this.handleAnswerRevealComplete} 
					handleGiveUp={this.handleGiveUp} 
					roundIsStarted={this.state.roundIsStarted} 
					blurGame={this.state.blurGame} 
					/>
			);
		}
		else {
			return(
				<Game 
					questionSet={this.state.questionSet} 
					handleCorrectAnswer={() => this.handleCorrectAnswer()} 
					key={this.state.uniqueID} 
					showAnswers={this.state.showAnswers} 
					totalAnswers={this.state.totalAnswers} 
					handleAnswerRevealComplete={this.handleAnswerRevealComplete} 
					handleGiveUp={this.handleGiveUp} 
					roundIsStarted={this.state.roundIsStarted} 
					blurGame={this.state.blurGame} 
					/>
			);
		}
	}

	renderVideoOverlay(){
		if(this.state.showVideoAd){
			return(
				<RewardAdContainer 
					showVideoAd={this.state.showVideoAd}
					handleVideoOverlayClose={this.handleVideoOverlayClose} 
					videoId={this.state.videoAdId}
					/>
			);
		}
	}

	render(){

		var roundMsg = "ROUND " + this.state.currentRound;

		if(this.state.currentRound > this.totalRounds){
			roundMsg = "BONUS ROUND";
		}

		return (
			<div className="page game">
				{this.renderVideoOverlay()}
				<div className="game_wrapper">
					<div className="content">
						{this.renderGame()}
					</div>
				</div>

				<div className="sidebar_wrapper">
					<div className="content">
						<SideBar 
							roundMsg={roundMsg} 
							totalPoints={this.state.totalPoints} 
							timerMsg={this.state.timerMsg} 
							blurGame={this.state.blurGame} 
							handleNeedMoreTimeBtnClick={this.handleNeedMoreTimeBtnClick} 
							showNeedMoreTimeBtn={this.state.showNeedMoreTimeBtn} 
							roundIsStarted={this.state.roundIsStarted} 
							currentRound={this.state.currentRound}
							/>
					</div>
				</div> 
				{this.renderInstructionsOverlay()}
				{this.renderResultsOverlay()}

				<div className="wipe" ref="wipe"></div>
			</div>
		);
	}
}

export default GamePage;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/GamePage.js